export function chunk<T>(array: T[], size: number): T[][] {
  const chunkedArr = []
  for (let i = 0; i < array.length; i++) {
    const last = chunkedArr[chunkedArr.length - 1]
    if (!last || last.length === size) {
      chunkedArr.push([ array[i] ])
    } else {
      last.push(array[i])
    }
  }
  return chunkedArr
}

export function flat<T>(arr: T[], depth: number): T[] {
  if ('flat' in arr) return (arr as any).flat(depth).filter(i => !Array.isArray(i))
  const innerAccum = []
  function reduceHandler(acc: any[], array: any[], innerDepth: number) {
    if (depth < 0) return [ ...acc ]
    return array.reduce((accum, curr) => {
      if (Array.isArray(curr)) reduceHandler(accum, curr, innerDepth - 1)
      else accum.push(curr)
      return accum
    }, acc)
  }
  reduceHandler(innerAccum, arr, depth)
  return innerAccum
}
